import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import CareersPage from './CareersPage';

const msp = (state, ownProps) => ({});

const mdp = (dispatch) => ({});

export default withRouter(connect(msp, mdp)(CareersPage));
